import { MOCK_USER, MOCK_USER_KEY } from './mock-user.const';

export function installMockUser(): void {
  if (window.localStorage.getItem(MOCK_USER_KEY) !== null) return;
  window.localStorage.setItem(MOCK_USER_KEY, JSON.stringify(MOCK_USER));
}
